<template lang="pug">
  extra-content(v-if="isPage" :extra="extra")
  extra-category-cards(v-else-if="menuHasCategory" :extra="extra")

</template>

<style lang="stylus" scoped>
.list-card
  display inline-block
  width 100%
  
</style>


<script>
import ExtraCategoryCards from './extra-category-cards'
import ExtraContent from './extra-content'

export default {
  props: ['extra', 'isPage', 'menu'],
  components: {
    ExtraCategoryCards,
    ExtraContent
  },
  computed: {
    isContent() {
      return this.contents.length === 1 && !!this.contents[0].images
    },
    contents() {
      if (this.extra && this.extra.content) {
        return JSON.parse(this.extra.content)
      } else {
        return [] 
      }
    },
    menuHasCategory() {
      return this.menu && this.menu.kind === 'category'
    }
  }
}
</script>
